// Small formatting helpers shared by the assessment-detail subcomponents.
// Kept pure — no React imports — so they're trivially unit-testable.

export function deepGet(obj, path) {
  if (!obj) return undefined;
  return path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);
}

export function fmtBool(v) {
  if (v === true) return "Yes";
  if (v === false) return "No";
  return null;
}

export function fmtMoney(v) {
  if (v == null || v === "") return null;
  const n = Number(v);
  if (Number.isNaN(n)) return String(v);
  return `A$${n.toLocaleString()}`;
}

export function fmtYears(w) {
  const sy = w.start_year || w.start_date;
  const ey = w.end_year || w.end_date;
  if (sy && ey) return `${sy} – ${ey}`;
  if (sy) return `${sy} – Present`;
  if (w.years) return `${w.years} yrs`;
  return "—";
}

// Produces a stable React key from any object/primitive. Falls back to a
// content-hash so we never have to rely on array indices (which break list
// re-ordering and trigger React rendering bugs).
export function stableKey(item, fallback = "") {
  if (item == null) return `null-${fallback}`;
  if (typeof item === "string" || typeof item === "number") {
    return `${item}-${fallback}`;
  }
  const parts = [
    item.id,
    item.note_id,
    item.entry_id,
    item.assessment_id,
    item.name,
    item.role_title,
    item.role,
    item.company,
    item.institution,
    item.qualification,
    item.field,
    item.start_year,
    item.start_date,
    item.year_completed,
    item.year,
  ].filter((v) => v !== undefined && v !== null && v !== "");
  if (parts.length > 0) return parts.join("|");
  try {
    return `${JSON.stringify(item)}-${fallback}`;
  } catch {
    return `obj-${fallback}`;
  }
}
